import { gql } from "@apollo/client";

export const MODULE_AUTHORIZATION_FRAGMENT = gql`
  fragment ModuleAuthorization on ModuleAuthorization {
    _id
    createdAt
    moduleSerialNumber
  }
`;
